import React from 'react';
import { T } from '../tokens';
import { Ico } from '../icons';

export interface AppHeaderProps {
  title: string;
  eyebrow?: string;
  onBack?: () => void;
  right?: React.ReactNode;
  accent?: string;
}

export function AppHeader({ title, eyebrow, onBack, right, accent }: AppHeaderProps) {
  const bg = accent || T.headerBg;
  const fg = accent ? T.onAccent : T.headerFg;
  return (
    <header style={{ position: 'sticky', top: 0, zIndex: 40, background: bg, color: fg, paddingTop: 'env(safe-area-inset-top)' }}>
      {/* 3-kolonne grid med lige brede sidekolonner → titlen står altid centreret */}
      <div style={{ minHeight: 58, display: 'grid', gridTemplateColumns: 'minmax(50px, 1fr) minmax(0, auto) minmax(50px, 1fr)', alignItems: 'center', gap: 10, padding: '9px 12px' }}>
        <div style={{ justifySelf: 'start' }}>
          {onBack
            ? <button onClick={onBack} aria-label="Tilbage" style={{ width: 38, height: 38, borderRadius: 11, border: 0, background: T.surface, color: T.headerFg, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}><Ico.chevL size={21} /></button>
            : <img src="/park-styling-forrest.svg" alt="PARK styling" style={{ width: 50, height: 'auto', display: 'block' }} />}
        </div>
        <div style={{ minWidth: 0, textAlign: 'center' }}>
          {eyebrow && <div style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', color: fg }}>{eyebrow}</div>}
          <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: '-0.01em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</div>
        </div>
        <div style={{ justifySelf: 'end', minWidth: 0, maxWidth: '100%', display: 'flex', justifyContent: 'flex-end' }}>{right}</div>
      </div>
    </header>
  );
}
